import { AccountSummary } from './AccountSummary';
import { Account } from './Account';

class AccountList {
  summary: AccountSummary;
  accounts: Account[];

  constructor(summary: AccountSummary, accounts: Account[]) {
    this.summary = summary;
    this.accounts = accounts;
  }
}

export { AccountList };
